export const getMyAnnonser = /* GraphQL */ `
  query GetMyAnnonser($userId: String!) {
    listJobRequests(filter: { userId: { eq: $userId } }) {
      items {
        id
        title
        startDate
        startNow
        description
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        jobLength
        company
        jobRequestComments {
          items {
            message
            id
            userId
            userFirstName
            userLastName
            userEmail
            userPhone
            userCompany
            status
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export const getAllInterestsByUser = /* GraphQL */ `
  query GetAllInterestsByUser($userId: String!) {
    listJobRequestComments(filter: { userId: { eq: $userId } }) {
      items {
        message
        id
        status
        jobRequest {
          company
          status
          description
          id06
          jobLength
          category
          county
          municipality
          startDate
          startNow
        }
      }
    }
  }
`;

export const getNotificationsByUser = /* GraphQL */ `
  query GetNotificationsByUser($userId: String!) {
    listNotifications(filter: { userId: { eq: $userId } }) {
      items {
        id
        userId
        category
        county
        municipality
        categoryName
      }
    }
  }
`;

export const getJobsByType = /* GraphQL */ `
  query getJobsByType($jobType: String!) {
    listJobRequests(filter: { jobType: { eq: $jobType } }) {
      items {
        id
        title
        startDate
        startNow
        description
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        jobType
        company
      }
    }
  }
`;
